import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useProjectConfig } from "../../context/ProjectConfigContext";

function DefaultFallback({ title, message }) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "76vh",
        pt: { xs: 18, md: 20 },
        px: 2,
        pb: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#f7f8fa",
      }}
    >
      <Box sx={{ maxWidth: 580, textAlign: "center" }}>
        {title ? (
          <Typography variant="h4" sx={{ fontWeight: 950, color: "#0D1F2D" }}>
            {title}
          </Typography>
        ) : null}
        {message ? (
          <Typography sx={{ mt: title ? 1.5 : 0, color: "#6b7280" }}>
            {message}
          </Typography>
        ) : null}
        <Button
          variant="contained"
          onClick={() => navigate("/")}
          sx={{
            mt: title || message ? 3 : 0,
            bgcolor: "#E64324",
            fontWeight: 900,
            textTransform: "none",
            borderRadius: 2,
            px: 4,
            "&:hover": { bgcolor: "#cc351b" },
          }}
        >
          Volver al inicio
        </Button>
      </Box>
    </Box>
  );
}

/**
 * Protege una vista según la switchera de módulos del proyecto.
 * Por defecto exige que todos los módulos indicados estén activos.
 */
export default function ModuleGate({
  modules = [],
  requireAll = true,
  children,
  fallback = null,
  title = "Función no disponible",
  message = "Este módulo no está habilitado para esta tienda.",
}) {
  const { isModuleEnabled } = useProjectConfig();
  const required = Array.isArray(modules) ? modules : [modules];
  const checks = required.filter(Boolean).map(isModuleEnabled);
  const allowed = requireAll ? checks.every(Boolean) : checks.some(Boolean);

  if (allowed) return children;
  if (fallback) return fallback;

  return <DefaultFallback title={title} message={message} />;
}
